import React from 'react';
import LoginFormContainer from '../../containers/login/LoginFormContainer';

const Login = () => {
  return <LoginFormContainer />;
};

export default Login;
